import useDynamicStore from 'client/hooks/useDynamicStore'
import PageUi from 'client/pages/ui/PageUi'
import React from 'react'
import { useTypography } from 'src/editor/shared/hooks/use-typography'
import websiteLoginReducer from 'src/editor/store/website-login/website-login-reducer'

export const WebsiteLoginPage = ({
  children,
}: {
  children: React.ReactNode
}) => {
  useDynamicStore({ key: 'websiteLogin', reducer: websiteLoginReducer })
  const { globalFontFamily, globalFontWeight, globalFontStyle } = useTypography(
    {},
  )

  return (
    <PageUi
      fontFamily={globalFontFamily}
      fontWeight={globalFontWeight}
      fontStyle={globalFontStyle}
    >
      {children}
    </PageUi>
  )
}
